import { ca } from '@cian/analytics';

export function trackPrintAllClick() {
  ca('event', {
    name: 'oldevent',
    action: 'print_ads',
    category: 'ListingFavorites',
    label: '',
  });
}

export function trackDownloadExcelClick() {
  ca('event', {
    name: 'oldevent',
    action: 'export_ads',
    category: 'ListingFavorites',
    label: '',
  });
}
